import SbRichtext from "./sb-richtext.vue";
export default {
  install: (app, options) => {
    app.component("sb-richtext", SbRichtext);
    const blocks = import.meta.glob("./blocks/*.vue", { eager: true });
    const marks = import.meta.glob("./marks/*.vue", { eager: true });

    Object.entries({ ...blocks, ...marks }).forEach(([path, definition]) => {
      const componentName = path
        .split("/")
        .pop()
        .replace(/\.\w+$/, "");
      app.component(componentName, definition.default);
    });
  },
};
